import React, { useState, useEffect } from 'react';
import { Container, Button, Form, Tab, Nav } from "react-bootstrap";
import { ProgramaDetails} from '../../../../service/types/types';
import ResumenPrograma from './tables/programa/resumenPrograma.table';
import { ProgramaService } from '../../../../service/programa.service';


export default function HistoricoPrograma() {
  const [date, setDate] = useState<string>("");
  const [programas, setProgramas] = useState<ProgramaDetails[]>([]);
  const [loading, setLoading] = useState(false);
  const [activeKey, setActiveKey] = useState<string>('');

  useEffect(() => {
    if (programas.length > 0) {
      setActiveKey(programas[0].id); // cuando cambias la fecha, selecciona la primera pestaña
    }
  }, [programas]);

  const handleActive = async (selected: string | null) => {
    if(selected) setActiveKey(selected);
  }

  const handleFetch = async () => {
    if (!date) return;
    setLoading(true);
    try {
      const data = await ProgramaService.query(date);
      setProgramas([]);
      setProgramas(data);
    } catch (error) {
      console.error("Error fetching programas:", error);
    } finally {
      setLoading(false);
    }
  };

  async function download() {
    await ProgramaService.downloadExcel(activeKey, date);
  }

  return (
    <Container fluid className="p-0">
      <div style={{ width: "100%", padding: "1rem" }}>
        {/* Input de fecha + botón */}
      <Form className="d-flex w-50 justify-content-start mb-3">
        <Form.Control
          type="date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
        />
        <Button
          variant="primary"
          className="ms-2"
          onClick={handleFetch}
          disabled={loading}
        >
          {loading ? "Cargando..." : "Seleccionar"}
        </Button>
      </Form>

        {/* Tabs */}
        {programas.length > 0 && (
          <Tab.Container activeKey={activeKey} onSelect={(k) => handleActive(k)}>
            {/* Botón de descarga */}
            <Nav variant="tabs">
              {programas.map((prog) => (
                <Nav.Item key={prog.id}>
                  <Nav.Link eventKey={prog.id}>
                    Programa {prog.fecha}
                  </Nav.Link>
                </Nav.Item>
              ))}
            </Nav>
            <Tab.Content>
              <Button
                variant="outline-secondary"
                size="sm"
                className="mt-3"
                onClick={() => {download()}}
              >
                Descargar detalles
              </Button>
              {programas.map((prog) => (
                <Tab.Pane eventKey={prog.id} key={prog.id}>
                  <br />
                  <h6>{prog.detalles}</h6>
                  <ResumenPrograma predios={prog.prediosPrograma} />
                </Tab.Pane>
              ))}
            </Tab.Content>
          </Tab.Container>
        )}
      </div>
    </Container>
  );
}